// extracted by mini-css-extract-plugin
export default {"root":"SnackbarComponent__root--3v7s6","succesIcon":"SnackbarComponent__succesIcon--16bI5","failedIcon":"SnackbarComponent__failedIcon--I-Wl5"};